import {AfterViewInit,Component,Input,OnChanges,OnInit} from '@angular/core';
import {ActivatedRoute,ParamMap,Router} from '@angular/router';
import {JhiAlertService,JhiEventManager} from 'ng-jhipster';
import {NotificateType} from 'src/app/shared/model/notification-type';
import {LanguageChangeService} from 'src/app/shared/services/language-change.service';
import {environment} from 'src/environments/environment';
import {PolicyMySuffixService} from '../policy-my-suffix/policy-my-suffix.service';
import {Principal} from './../../core/auth/principal.service';
import {NotificationEventTriggerByGroup} from './../../core/user/notification-event-trigger.model';
import {NotificationPreferenceService} from './notification-preference.service';
import { TypeOfClient } from 'src/app/shared/model/client.model';
import { CommonUtils } from 'src/app/shared/util/common-utils';


@Component({
    selector: 'jhi-notification-preference-detail',
    templateUrl: './notification-preference-my-suffix-detail.component.html'
})
export class NotificationPreferenceMySuffixDetailComponent implements AfterViewInit, OnInit, OnChanges {
    @Input() id: number;
    userId :number;
    ngOnInit() {
        this.userId = this.id;
        console.log(this.id);
    }
    
    ngOnChanges() {
        console.log(this.id);
        
    }

    keys = Object.keys;
    values = Object.values;
  
    // _notificationEventTrigger: NotificationEventTrigger[];
    _notificationEventTrigger: NotificationEventTriggerByGroup;
    notificationEventTriggerSorted=[];
    selectedClient=environment.login
    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private jhiAlertService: JhiAlertService,
        private principal: Principal,
        private eventManager: JhiEventManager,
        private service: NotificationPreferenceService,
        private policyService: PolicyMySuffixService,
        private languageChangeService: LanguageChangeService
    ) {
        this.languageChangeService.refreshLanguage();
         this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            const refresh = paramMap.get('refresh');
            if (refresh) {
                 
                this.languageChangeService.refreshLanguage();
            }
    });
    }
    whoIsResponsibleForCashingPremiums : any;
    ngAfterViewInit() {
        if (this.id) {
            // let url = "api/policies/cashing-premiums";
            // this.policyService.getByUrl(url).subscribe(res=>{
            //     this.whoIsResponsibleForCashingPremiums = res.body.whoIsResponsibleForCashingPremiums  
            // },err=>{});

            this.service.find(this.id).subscribe(data => {
                this.notificationEventTrigger = data.body
                console.log(this.notificationEventTrigger)
                this.notificationEventTriggerSorted.push([NotificateType.CERTIFICATE_REQUEST,this.notificationEventTrigger[NotificateType.CERTIFICATE_REQUEST]]);
                this.notificationEventTriggerSorted.push([NotificateType.CERTIFICATE,this.notificationEventTrigger[NotificateType.CERTIFICATE]]);
                this.notificationEventTriggerSorted.push([NotificateType.LOSS_PAYEE, this.notificationEventTrigger[NotificateType.LOSSPAYEE]]);
                if (this.principal.userIdentity.authorities[0] === "BROKER" || this.principal.userIdentity.authorities[0] === "BROKER_STAFF" || this.principal.userIdentity.authorities[0] === "UNDERWRITER" || this.principal.userIdentity.authorities[0] === "UNDERWRITER_STAFF") {
                    this.notificationEventTriggerSorted.push([NotificateType.DELEGATIONS, this.notificationEventTrigger[NotificateType.DELEGATIONS]]);
                }
                if(this.principal.userIdentity && (this.principal.userIdentity.typeOfClient != TypeOfClient.FREIGHT_FORWARDER)){
                    this.notificationEventTriggerSorted.push([NotificateType.STORAGE,this.notificationEventTrigger[NotificateType.STORAGE]]);
                }
                if(this.principal.userIdentity && (this.principal.userIdentity.typeOfClient == TypeOfClient.FREIGHT_FORWARDER
                    || this.principal.userIdentity.typeOfClient == TypeOfClient.TRADER)){
                        if (CommonUtils.isNotNil(this.notificationEventTrigger[NotificateType.ACCOUNTING])) {
                                this.notificationEventTriggerSorted.push([NotificateType.ACCOUNTING,this.notificationEventTrigger[NotificateType.ACCOUNTING]]);
                        }
                }

                let isAdminUsers=this.principal.userIdentity && (this.principal.userIdentity.authorities[ 0 ]==="BROKER"|| this.principal.userIdentity.authorities[ 0 ]==="BROKER_STAFF"||
                    this.principal.userIdentity.authorities[ 0 ]==="INSURER"|| this.principal.userIdentity.authorities[ 0 ]==="INSURER_STAFF"||
                    this.principal.userIdentity.authorities[ 0 ]==="UNDERWRITER"|| this.principal.userIdentity.authorities[ 0 ]==="UNDERWRITER_STAFF");
            
                if(isAdminUsers && this.principal.userIdentity.enableAccounting && this.principal.userIdentity.enablePremiumCalculation){
                    this.notificationEventTriggerSorted.push([NotificateType.ACCOUNTING,this.notificationEventTrigger[NotificateType.ACCOUNTING]]);
                }

                if(isAdminUsers && this.principal.checkForEnableSanctionScreening()) {
                    this.notificationEventTriggerSorted.push([ NotificateType.FINSCAN,this.notificationEventTrigger[ NotificateType.FINSCAN ] ]);  
                }
                
                this.notificationEventTriggerSorted.push([NotificateType.POLICY_RENEWAL,this.notificationEventTrigger[NotificateType.POLICY_RENEWAL]]);  
            })
        }
    }

    set notificationEventTrigger(notificationEventTrigger: NotificationEventTriggerByGroup) {
        this._notificationEventTrigger = notificationEventTrigger;
    }

    get notificationEventTrigger() {
        return this._notificationEventTrigger;
    }


    previousState() {
        window.history.back();
    }
    get authority() {
        return this.principal.userIdentity.authorities[0];
    }
}
